import { lazy } from 'react';
import { GuestGuard } from '@/components/auth';

// AUTHENTICATION PAGES
const Login = lazy(() => import('@/pages/sessions/login'));
const Register = lazy(() => import('@/pages/sessions/register'));
const ForgetPassword = lazy(() => import('@/pages/sessions/forget-password'));
const SSOCallback = lazy(() => import('@/pages/sessions/sso-callback'));

export const AuthRoutes = [
  // SSO CALLBACK - No guard needed, handles OAuth redirect
  {
    path: 'sso-callback',
    element: <SSOCallback />
  },
  // AUTHENTICATION PAGES ROUTES
  {
    element: <GuestGuard />,
    children: [
      {
        path: 'login',
        element: <Login />
      },
      {
        path: 'register',
        element: <Register />
      },
      {
        path: 'forget-password',
        element: <ForgetPassword />
      }
    ]
  }
];
